import React from "react";

function Activity() {
  return (
    <div className="">
      <h3>Activities</h3>
    </div>
  );
}

export default Activity;
